import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { ManualService } from 'src/app/services/panelM/manual.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';

@Component({
  standalone: false,
  selector: 'app-manual',
  templateUrl: './manual.component.html',
  styleUrls: ['./manual.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class ManualComponent implements OnInit {

  search: UntypedFormGroup;
  treeControl = new NestedTreeControl<any>(node => node.Parameters);
  params = new MatTreeNestedDataSource<any>();
  aux: any;
  entity: any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private readonly router: Router, private man: ManualService, private snackBar: MatSnackBar, private fBuilder: UntypedFormBuilder) { }

  ngOnInit() {
    this.search = this.fBuilder.group({
      result: new UntypedFormControl('', [])
    }, {});
    this.man.manualDataService().subscribe((data: any) => {
     data.BanksList[0].label = true;
      setTimeout(() => {
        this.params.data = data.BanksList;
        this.aux = data.BanksList;
      }, 100);

    }, error => {
      console.error(error);
      this.router.navigateByUrl('/portalM');
    });
    this.searchItem();
  }

  hasChild = (_: number, node: any) => !!node.Parameters && node.Parameters.length > 0;

  updateCodeBank = (entity) => this.entity = entity;

  updateRow(element) {
    this.man.updateManual(element).subscribe((data: any) => {
      this.snackBar.open((data.Ok) ? 'Actualización correcta' : 'Error al actualizar', '', {
        duration: 3000,
      });
    }, (data) => {
      this.snackBar.open((data.Ok) ? 'Actualización correcta' : 'Error al actualizar', '', {
        duration: 3000,
      });
    });
  }

  updateRowNode(element: any) {
    element = this.getValuesEntity(element);
    this.man.updateManual(element).subscribe((data: any) => {
      this.snackBar.open((data.Ok) ? 'Actualización correcta' : 'Error al actualizar', '', {
        duration: 3000,
      });
    }, (data) => {
      this.snackBar.open((data.Ok) ? 'Actualización correcta' : 'Error al actualizar', '', {
        duration: 3000,
      });
    });
  }

  getValuesEntity = (element) => {
    element.CodeBank = this.entity.CodeBank;
    element.Flag_Visible = this.entity.Flag_Visible;
    element.Name = this.entity.Name;
    element.RobotPSD2 = this.entity.RobotPSD2;
    return element;
  }

  searchItem() {
    this.search.valueChanges.subscribe(data => {
      const v = this.search.get('result').value;
      if (v === '') {
        this.params.data = this.aux;
        return;
      } else {
        this.params.data = this.params.data.filter(d => d.Name.trim().toLowerCase().includes(v.trim().toLowerCase()));
      }
    });
  }
}
